export const listMutations = <const>{
	ZAKAZNIK_SELECT_MAPPER: 'ZAKAZNIK_SELECT_MAPPER',
	TYPKOD_SELECT_MAPPER: 'TYPKOD_SELECT_MAPPER',
};
